// import React, { useEffect } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import { Container, Row, Col, Card, Button } from 'react-bootstrap';
// import { FaServer, FaShieldAlt, FaSyncAlt, FaDatabase, FaHeadset } from 'react-icons/fa';
// import '../styles/Managed.css';  // Reuse same styles

// const ManagedServices = () => {
//   useEffect(() => {
//     AOS.init({ duration: 800, once: true });
//   }, []);

//   return (
//     <div className="desktop-support py-5">
//       {/* Hero Section */}
//       <Container className="mb-5" data-aos="fade-down">
//         <Row className="align-items-center">
//           <Col md={6} className="mb-4 mb-md-0">
//             <h1 className="fw-bold hero-title">Managed Services</h1>
//             <p className="text-muted hero-tagline">
//               Comprehensive IT support to streamline your operations and boost efficiency.
//             </p>
//           </Col>
//           <Col md={6} data-aos="fade-left">
//             <video
//               src="/videos/managed_services.mp4"
//               className="img-fluid rounded shadow network-video mt-5"
//               autoPlay
//               loop
//               muted
//               playsInline
//             />
//           </Col>
//         </Row>
//         <div className="divider my-5"></div>
//       </Container>

//       {/* Overview Section */}
//       <Container className="mb-5" data-aos="fade-up">
//         <h3 className="fw-bold text-center mb-3">Comprehensive Managed Services</h3>
//         <p className="text-muted text-center mb-4 mx-auto info-text">
//           Our managed services provide ongoing support and management of your IT infrastructure, allowing you to focus on your core business activities. We offer proactive monitoring, maintenance, and support to ensure your systems are always running efficiently.
//         </p>
//         <Row className="justify-content-center">
//           <Col md={8}>
//             <ul className="list-unstyled support-list">
//               <li data-aos="fade-right"> IT infrastructure management</li>
//               <li data-aos="fade-right" data-aos-delay="100"> Proactive monitoring and maintenance</li>
//               <li data-aos="fade-right" data-aos-delay="200"> Security management</li>
//               <li data-aos="fade-right" data-aos-delay="300"> Data backup and recovery</li>
//               <li data-aos="fade-right" data-aos-delay="400"> Helpdesk support</li>
//             </ul>
//           </Col>
//         </Row>
//         <div className="divider my-5"></div>
//       </Container>

//       {/* Features Section */}
//       <Container className="mb-5">
//         <Row className="g-4">
//           <Col md={4} data-aos="fade-up">
//             <Card className="p-4 text-center h-100 shadow-sm glass-card">
//               <FaServer size={40} className="text-primary mb-3" />
//               <h5>Infrastructure Management</h5>
//               <p className="text-muted">End-to-end support for all your IT systems and hardware.</p>
//             </Card>
//           </Col>
//           <Col md={4} data-aos="fade-up" data-aos-delay="100">
//             <Card className="p-4 text-center h-100 shadow-sm glass-card">
//               <FaSyncAlt size={40} className="text-success mb-3" />
//               <h5>Proactive Monitoring</h5>
//               <p className="text-muted">Identify and resolve issues before they impact your business.</p>
//             </Card>
//           </Col>
//           <Col md={4} data-aos="fade-up" data-aos-delay="200">
//             <Card className="p-4 text-center h-100 shadow-sm glass-card">
//               <FaShieldAlt size={40} className="text-danger mb-3" />
//               <h5>Security Management</h5>
//               <p className="text-muted">Protect your infrastructure with real-time threat detection.</p>
//             </Card>
//           </Col>
//         </Row>
//         <div className="divider my-5"></div>
//       </Container>

//       {/* Additional Services Section */}
//       <Container className="mb-5">
//         <Row className="g-4">
//           <Col md={6} data-aos="zoom-in">
//             <Card className="p-4 text-center h-100 shadow-sm glass-card">
//               <FaDatabase size={35} className="text-info mb-3" />
//               <h6>Data Backup & Recovery</h6>
//               <p className="text-muted">Ensure business continuity with automated backup solutions.</p>
//             </Card>
//           </Col>
//           <Col md={6} data-aos="zoom-in" data-aos-delay="100">
//             <Card className="p-4 text-center h-100 shadow-sm glass-card">
//               <FaHeadset size={35} className="text-warning mb-3" />
//               <h6>Helpdesk Support</h6>
//               <p className="text-muted">Our support team is available to solve user issues swiftly.</p>
//             </Card>
//           </Col>
//         </Row>
//         <div className="divider my-5"></div>
//       </Container>

//       {/* Why Choose Us */}
//       <Container className="mb-5">
//         <h3 className="text-center fw-bold mb-4" data-aos="fade-right">Why Choose SEPL's Managed Services?</h3>
//         <Row className="g-4">
//           <Col md={6} lg={3} data-aos="fade-right">
//             <Card className="text-center p-4 shadow-sm glass-card">
//               <h6>Expert Team</h6>
//               <p className="text-muted">Certified professionals managing your IT landscape.</p>
//             </Card>
//           </Col>
//           <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="100">
//             <Card className="text-center p-4 shadow-sm glass-card">
//               <h6>24/7 Monitoring</h6>
//               <p className="text-muted">We monitor and support your systems round the clock.</p>
//             </Card>
//           </Col>
//           <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="200">
//             <Card className="text-center p-4 shadow-sm glass-card">
//               <h6>Customized Solutions</h6>
//               <p className="text-muted">Tailored services to suit your business goals.</p>
//             </Card>
//           </Col>
//           <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="300">
//             <Card className="text-center p-4 shadow-sm glass-card">
//               <h6>Scalable Services</h6>
//               <p className="text-muted">Grow your business with flexible service plans.</p>
//             </Card>
//           </Col>
//         </Row>
//         <div className="divider my-5"></div>
//       </Container>

//       {/* Call to Action */}
//       <Container className="text-center mt-5" data-aos="zoom-in">
//         <h4 className="fw-bold mb-3">Let Us Manage Your IT, So You Can Manage Your Business</h4>
//         <p className="text-muted mb-4">Contact OverAir today and streamline your IT operations.</p>
//         <Button
//           variant="primary"
//           href="/contact"
//           className="cta-button shadow"
//         >
//           Contact Us
//         </Button>
//       </Container>
//     </div>
//   );
// };

// export default ManagedServices;


import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaServer, FaShieldAlt, FaSyncAlt, FaDatabase, FaHeadset } from 'react-icons/fa';
import '../styles/Managed.css';

const ManagedServices = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="desktop-support py-5">
      {/* Hero Section */}
      <Container className="mb-5" data-aos="fade-down">
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <h1 className="fw-bold hero-title">Managed Services</h1>
            <p className="text-muted hero-tagline">
              Managed Services offer a complete solution for maintaining, monitoring, and supporting your IT infrastructure. With a focus on reliability and efficiency, these services ensure that systems remain secure, updated, and optimized—minimizing downtime and reducing operational risks.
              Key offerings include infrastructure management, proactive system monitoring, security threat detection, data backup and recovery, and user helpdesk support. 
            </p>
          </Col>
          <Col md={6} data-aos="fade-left">
            <video
              src="/videos/managed_services.mp4"
              className="img-fluid rounded shadow network-video mt-5"
              autoPlay
              loop
              muted
              playsInline
            />
          </Col>
        </Row>
        {/* <div className="divider my-5"></div> */}
      </Container>

      {/* Overview Section */}
      <Container className="mb-5" data-aos="fade-up">
        <h3 className="fw-bold text-center mb-3">Comprehensive Managed Services</h3>
        <p className="text-muted text-center mb-4 mx-auto info-text">
          Our managed services provide ongoing support and management of your IT infrastructure, allowing you to focus on your core business activities. We offer proactive monitoring, maintenance, and support to ensure your systems are always running efficiently.
        </p>
        <Row className="justify-content-center">
          <Col md={8}>
            <ul className="list-unstyled support-list">
              <li data-aos="fade-right">IT infrastructure management</li>
              <li data-aos="fade-right" data-aos-delay="100">Proactive monitoring and maintenance</li>
              <li data-aos="fade-right" data-aos-delay="200">Security management</li>
              <li data-aos="fade-right" data-aos-delay="300">Data backup and recovery</li>
              <li data-aos="fade-right" data-aos-delay="400">Helpdesk support</li>
            </ul>
          </Col>
        </Row>
        {/* <div className="divider my-5"></div> */}
      </Container>

      {/* Features Section */}
      <Container className="mb-5">
        <Row className="g-4">
          <Col md={4} data-aos="fade-up">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaServer size={40} className="text-primary mb-3" />
              <h5>Infrastructure Management</h5>
              <p className="text-muted">End-to-end support for all your IT systems and hardware.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="100">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaSyncAlt size={40} className="text-success mb-3" />
              <h5>Proactive Monitoring</h5>
              <p className="text-muted">Identify and resolve issues before they impact your business.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="200">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaShieldAlt size={40} className="text-danger mb-3" />
              <h5>Security Management</h5>
              <p className="text-muted">Protect your infrastructure with real-time threat detection.</p>
            </Card>
          </Col>
        </Row>
        {/* <div className="divider my-5"></div> */}
      </Container>

      {/* Additional Services */}
      <Container className="mb-5">
        <Row className="g-4">
          <Col md={6} data-aos="zoom-in">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaDatabase size={35} className="text-info mb-3" />
              <h6>Data Backup & Recovery</h6>
              <p className="text-muted">Ensure business continuity with automated backup solutions.</p>
            </Card>
          </Col>
          <Col md={6} data-aos="zoom-in" data-aos-delay="100">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaHeadset size={35} className="text-warning mb-3" />
              <h6>Helpdesk Support</h6>
              <p className="text-muted">Our support team is available to solve user issues swiftly.</p>
            </Card>
          </Col>
        </Row>
        {/* <div className="divider my-5"></div> */}
      </Container>

      {/* Why Choose Us */}
      <Container className="mb-5">
        <h3 className="text-center fw-bold mb-4" data-aos="fade-right">Why Choose SEPL's Managed Services?</h3>
        <Row className="g-4">
          <Col md={6} lg={3} data-aos="fade-right">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Expert Team</h6>
              <p className="text-muted">Certified professionals managing your IT landscape.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="100">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>24/7 Monitoring</h6>
              <p className="text-muted">We monitor and support your systems round the clock.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="200">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Customized Solutions</h6>
              <p className="text-muted">Tailored services to suit your business goals.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="300">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Scalable Services</h6>
              <p className="text-muted">Grow your business with flexible service plans.</p>
            </Card>
          </Col>
        </Row>
        {/* <div className="divider my-5"></div> */}
      </Container>

      {/* CTA */}
      <Container className="text-center mt-5" data-aos="zoom-in">
        <h4 className="fw-bold mb-3">Let Us Manage Your IT, So You Can Manage Your Business</h4>
        <p className="text-muted mb-4">Contact OverAir today and streamline your IT operations.</p>
        <Button variant="primary" href="/contact" className="cta-button shadow">
          Contact Us
        </Button>
      </Container>
    </div>
  );
};

export default ManagedServices;
